<template>
  <button :disabled="loading" :class="classes">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'VButton',

  props: {
    loading: {
      type: Boolean,
      default: false
    },

    classes: Object,
  }
}
</script>
